import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 11.3137,
		cy: 11.3137,
		r: 7.4,
		transform: "rotate(-45 11.3137 11.3137)",
		stroke: "#BDBDBD",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("line", {
		x1: 17.3948,
		y1: 16.5462,
		x2: 22.5374,
		y2: 21.6888,
		stroke: "#BDBDBD",
		strokeWidth: 1.2
	})]
});
export default SvgSearch;
